var _path, _g, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgSecurityPopupIcon = function SvgSecurityPopupIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 188,
    height: 189,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#security-popup-icon_svg__a)",
    d: "M80.734 24.844 59.59 37.999c-6.212 3.865-9.318 5.798-10.965 9.191s-1.293 6.595-.584 12.998c4.566 41.213 28.168 57.859 39.883 63.662 2.369 1.173 3.553 1.76 6.61 1.76 3.059 0 4.243-.587 6.612-1.76 11.714-5.803 35.317-22.449 39.882-63.662.709-6.403 1.064-9.604-.583-12.998-1.648-3.393-4.754-5.326-10.966-9.19l-21.142-13.156c-6.713-4.177-10.07-6.266-13.802-6.266s-7.089 2.089-13.802 6.266Z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#security-popup-icon_svg__b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#6AE092",
    fillOpacity: 0.6,
    d: "M57.898 57.47 42.49 66.272c-1.918 1.096-3.112 3.177-3.055 5.385 1.611 62.698 45.027 79.824 53.627 82.606a4.74 4.74 0 0 0 2.945 0c8.601-2.782 52.016-19.908 53.627-82.606.057-2.208-1.137-4.289-3.054-5.385l-15.408-8.804a73.85 73.85 0 0 0-73.275 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "url(#security-popup-icon_svg__c)",
    strokeWidth: 0.612,
    d: "m42.642 66.539 15.408-8.804a73.54 73.54 0 0 1 72.972 0l15.407 8.804c1.821 1.04 2.954 3.018 2.901 5.11-.804 31.272-12.029 51.155-24.107 63.567-12.083 12.419-25.037 17.375-29.31 18.757a4.4 4.4 0 0 1-2.756 0c-4.272-1.382-17.225-6.338-29.31-18.757-12.076-12.412-23.302-32.295-24.105-63.566-.054-2.093 1.079-4.07 2.9-5.111Z"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#security-popup-icon_svg__d)",
    fillOpacity: 0.9,
    stroke: "url(#security-popup-icon_svg__e)",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.49,
    d: "M90.424 107.13a.245.245 0 0 0 .346 0l23.395-23.395a5.663 5.663 0 1 1 8.009 8.01l-27.573 27.573a5.665 5.665 0 0 1-8.01 0l-15.755-15.756a5.664 5.664 0 1 1 8.01-8.01z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "security-popup-icon_svg__a",
    x1: 42.875,
    x2: 146.311,
    y1: 28.5,
    y2: 45.595,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2020C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#20C472"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "security-popup-icon_svg__c",
    x1: 41.517,
    x2: 178.246,
    y1: 61.6,
    y2: 162.43,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.734,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "security-popup-icon_svg__d",
    x1: 77.55,
    x2: 163.717,
    y1: 96.85,
    y2: 107.033,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "security-popup-icon_svg__e",
    x1: 70.5,
    x2: 105.75,
    y1: 87.45,
    y2: 99.2,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("filter", {
    id: "security-popup-icon_svg__b",
    width: 134.818,
    height: 131.375,
    x: 27.126,
    y: 35.432,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    "in": "BackgroundImageFix",
    stdDeviation: 6.154
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_995_581"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_backgroundBlur_995_581",
    result: "shape"
  })))));
};
export default SvgSecurityPopupIcon;